import PropTypes from 'prop-types';

export const propTypes = {
  onChange: PropTypes.func,
};

export const defaultProps = {
  onChange: () => {},
};
